module.exports = __webpack_public_path__ + "img/close-3.9ace7a50.svg";